var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 74,
    viewBox: "0 0 92 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2188_30518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6133 0L84.64 10.4267L56.4267 26.9867L38.0267 48.4533L17.7867 56.4267L0 74.8267",
    stroke: "#47B881",
    strokeWidth: 1.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.64 10.4267L92.6133 0V74.8267H0L17.7867 56.4267L38.0267 48.4533L56.4267 26.9867L84.64 10.4267Z",
    fill: "url(#paint0_linear_2188_30518)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2188_30518",
    x1: 224.48,
    y1: -32.5067,
    x2: -0.00000182946,
    y2: 74.8267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B881",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2188_30518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRising);
export default __webpack_public_path__ + "static/media/rising.6b52b602a56703949b6ea46c4ab3b866.svg";
export { ForwardRef as ReactComponent };